// One distinct color per scale degree, so every tone of any overlay reads as its own color on
// the neck. The root keeps the same blue in the legend and on the board.
export const DEGREE_COLORS: Record<number, string> = {
  1: "#1976d2", // blue — root
  2: "#00838f", // teal
  3: "#7b1fa2", // purple
  4: "#c62828", // red
  5: "#2e7d32", // green
  6: "#e65100", // orange
  7: "#795548", // brown
};
